module.exports = __webpack_public_path__ + "204cb90d0765e31a12f06b40c5405985.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/small/leonardo-da-vinci.jpg
 ** module id = 410
 ** module chunks = 0
 **/